module.exports = __webpack_public_path__ + "img/bg.10e1bfa7.png";